import { styled } from '@mui/material/styles';
import { Card } from '@mui/material';

export const ContainerGraphics = styled(Card)(({ width }) => {
    return {
        display: 'flex',
        flexDirection: 'column',
        height: '335px',
        width: width,
        padding: '10px',
        overflowX: 'auto !important',
		borderRadius: '10px',
        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
        '&::-webkit-scrollbar': {
            height: '5px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
        } 
    }
});